module.exports = __webpack_public_path__ + "static/media/pathImg.735e3790.jpg";